<template>
  <v-row>
    <!-- Edit DIALOG -->
    <div class="text-center">
      <v-dialog v-model="editDialog" width="400">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="clickable"
            @click="setFollowUp(followup)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <v-card>
          <v-card-title> Edit folowup </v-card-title>
          <v-card-text>
            <template v-if="!completedHandler">
              <datetime
                placeholder="Click to Pick date and time"
                class="datetime-style"
                type="datetime"
                v-model="edit.datetime"
                use12-hour
              ></datetime>
              <v-textarea
                class="mt-2"
                label="Description"
                v-model="edit.description"
                rows="3"
              ></v-textarea>
              <v-select
                v-model="edit.priority"
                :items="priorities"
                item-text="value"
                item-value="key"
                menu-props="auto"
                label="Priority"
                required
              />
            </template>
            <v-checkbox v-model="edit.completed" label="Completed"></v-checkbox>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="editDialog = false">
              Close
            </v-btn>
            <v-btn
              color="green"
              :disabled="!edit.datetime"
              @click="editFollowup(edit.id)"
              text
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- DELETE DIALOG -->
    <div class="text-center" v-if="user.role_id == 1">
      <v-dialog v-model="deleteDialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="clickable"
            @click="setId(followup.id)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <v-card>
          <v-card-title> Delete folow-up </v-card-title>
          <v-card-text>
            Are you sure want to delete this followup.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDialog = false">
              Close
            </v-btn>
            <v-btn color="red" @click="deleteFollowup()" text> Delete </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- COMPLETED DIALOG -->
    <div
      class="text-center"
      v-if="followup.completed == 'In Progress' || !followup.completed"
    >
      <v-dialog v-model="completeDialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="clickable"
            @click="setId(followup.id)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-check
          </v-icon>
        </template>
        <v-card>
          <v-card-title> Complete folowup </v-card-title>
          <v-card-text>
            Are you sure want to complete this followup.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="completeDialog = false">
              Close
            </v-btn>
            <v-btn color="green" @click="completedFollowup()" text>
              Complete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FollowUpsTableActions",
  data() {
    return {
      deleteDialog: false,
      completeDialog: false,
      editDialog: false,
      completedHandler: false,
      edit: {
        completed: 0,
        datetime: null,
        description: null,
        priority: 3,
      },
    };
  },
  props: ["followup"],
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      loadFollowupsByFilters: "followups/loadFollowupsByFilters",
    }),
    setId(id) {
      this.id = id;
    },
    setFollowUp(item) {
      this.id = item.id;
      let dateTime = new Date(item.datetime)
      this.edit.datetime = dateTime.toISOString();
      this.edit.completed = item.completed;
      if (
        this.edit.completed == "Completed" ||
        this.edit.completed == "In Progress"
      ) {
        this.edit.completed = this.edit.completed == "Completed" ? 1 : 0;
      }

      this.completedHandler = this.edit.completed;
      this.edit.description = item.description;
      const priorityIndex = this.priorities.findIndex(
        (priority) => priority.value === item.priority
      );
      this.edit.priority = this.priorities[priorityIndex].key;
    },
    completedFollowup() {
      this.$axios
        .post("/followup/update", {
          id: this.id,
          followup: { completed: 1 },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.completeDialog = false;
          this.loadFollowupsByFilters({
            params: this.filters,
            user_id: this.user.id,
          });
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
    deleteFollowup() {
      this.$axios
        .post("/followup/delete", {
          id: this.id,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.deleteDialog = false;
          this.loadFollowupsByFilters({
            params: this.filters,
            user_id: this.user.id,
          });
          this.clearFilters();
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
    editFollowup() {
      this.$axios
        .post("/followup/update", {
          id: this.id,
          followup: this.edit,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.deleteDialog = false;
          this.loadFollowupsByFilters({
            params: this.filters,
            user_id: this.user.id,
          });
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      priorities: "followups/priorities",
      filters: "filters/followUpFilters",
      followups: "followups/user_followups",
      user: "auth/user",
      statuses: "followups/statuses",
    }),
  },
};
</script>

<style>
</style>